import Vue from 'Vue';
import Cookies from 'browser-cookies';
import localForage from 'localforage';
import {
  scrollToStep,
  scrollToFirstError
} from './util';

/* global _as_rest */
/* eslint camelcase: 0 */

const {
  customer_hash
} = _as_rest;

window.$asEventBus = window.$asEventBus || new Vue();

const DEFAULT_REACHED = {
  productMatrix: true,
  customerDetails: false,
  payment: false,
  confirmation: false
};
const DEFAULT_EDITABLE = {
  productMatrix: false,
  customerDetails: false,
  payment: false,
  confirmation: false
};

const calculateEditable = current => {
  const editable = {
    ...DEFAULT_EDITABLE
  };

  if ('customer-details' === current) {
    editable.productMatrix = true;
  }

  if ('payment' === current) {
    editable.productMatrix = true;
    editable.customerDetails = true;
  }

  return editable;
};
const calculateCurrent = ({
  current,
  editable = {
    ...DEFAULT_EDITABLE
  },
  completed = false,
  edit = false
}) => {
  if (completed && completed !== current) {
    return current;
  }

  if ('confirmation' === current || 'payment' === completed) {
    return 'confirmation';
  }

  if (('payment' === edit && editable.payment) || 'customer-details' === completed) {
    return 'payment';
  }

  if (('customer-details' === edit && editable.customerDetails) || 'product-matrix' === completed) {
    return 'customer-details';
  }

  if ('product-matrix' === edit && editable.productMatrix) {
    return 'product-matrix';
  }

  return current;
};
const calculateReached = ({
  reached = {
    ...DEFAULT_REACHED
  },
  current
}) => {
  if ('customer-details' === current) {
    reached.customerDetails = true;
  }

  if ('payment' === current) {
    reached.payment = true;
  }

  if ('confirmation' === current) {
    reached.confirmation = true;
  }

  return reached;
};

const $eventBus = window.$asEventBus;
const Apps = [];
const DEFAULT_STATE = {
  current: 'product-matrix',
  editable: {
    ...DEFAULT_EDITABLE
  },
  reached: {
    ...DEFAULT_REACHED
  },
  orderItems: {},
  order: null,
  customer: null,
  payments: {}
};
let state;

const initState = () => {
  if (!state) {
    let cookie = Cookies.get('_as_init');

    if (cookie) {
      const json = JSON.parse(decodeURIComponent(cookie));

      if (json.current) {
        localForage.setItem(customer_hash, json);
        state = json;

        return;
      }
    }

    return localForage
      .getItem(customer_hash)
      .then(_state => {
        if (_state && _state.current) {
          state = _state;
        } else {
          state = DEFAULT_STATE;
        }
      })
      .catch(() => {
        state = DEFAULT_STATE;
      })
    ;
  }

  return Promise.resolve();
};

initState();

$eventBus.$on('mounted', async App => {
  Apps.push(App);

  await initState();

  App.$data.order_state = state;
});

$eventBus.$on('has-error', scrollToFirstError);

$eventBus.$on('reset', async() => {
  state = {
    ...DEFAULT_STATE
  };

  await localForage.clear();
  await localForage.setItem(customer_hash, state);

  Apps.forEach(App => {
    App.$data.order_state = {
      ...state
    };
  });

  scrollToStep('product-matrix');
});

$eventBus.$on('order-updated', async data => {
  await initState();

  const completed = data.completed || false;
  const edit = data.edit || false;

  delete data.completed;
  delete data.edit;

  const current = calculateCurrent({
    current: state.current,
    editable: state.editable,
    completed,
    edit
  });

  const currentHasChanged = state.current !== current;

  state = {
    ...state,
    ...data,
    current,
    editable: calculateEditable(current),
    reached: calculateReached({
      reached: state.reached,
      current
    })
  };

  await localForage.setItem(customer_hash, state);

  Apps.forEach(App => {
    App.$data.order_state = {
      ...state
    };
  });

  if (currentHasChanged) {
    scrollToStep(current);
  }

  if ('confirmation' === current) {
    await localForage.clear();
  }
});

export default $eventBus;
